import { FIREBASE_STORAGE_SINGLE_PATTERNS_URL } from '../config/constants';

export const getFileNameAndMediaTokenFromURL = (url) => {
	const regex =
		/singlePatterns%2F([a-zA-Z0-9]+)\.pdf\?alt=media&token=([a-f0-9-]+)/;

	const matches = url.match(regex);

	if (matches) {
		const n = matches[1];
		const mt = matches[2];
		return { n, mt };
	}
};

export const getURLFromFileNameAndMediaToken = (fileName, mediaToken) => {
	return `${FIREBASE_STORAGE_SINGLE_PATTERNS_URL}${fileName}.pdf?alt=media&token=${mediaToken}`;
};

export const getSinglePatternURLFromFileNameAndMediaToken = (
	fileName,
	mediaToken,
) => {
	if (!fileName) {
		return '';
	}
	const baseUrl = window.location.origin;
	let url = `${baseUrl}/sp?n=${fileName}`;
	if (!!mediaToken) {
		url += `&mt=${mediaToken}`;
	}
	return url;
};
